import { getApi } from "../utils/api";
import { EMPLOYEE_LIST } from "../config/Endpoints";
import Cookies from "js-cookie";

export const fetchEmployeesListService = async (set) => {
  set({ loading: true });
  try {
    const accessToken = Cookies.get("accessToken");
    const res = await getApi(EMPLOYEE_LIST, accessToken);
    const users = res.data?.data || [];
    const options = users.map((u) => ({
      value: u.id,
      label: u.empName,
    }));
    set({ employeeList: options, loading: false });
  } catch (err) {
    console.error("Error fetching employees:", err);
    set({ loading: false });
  }
};
